import { ITopicMinimal } from "@/api";
import { Chip, Stack, Typography } from "@mui/material";

interface IProps {
    topics: ITopicMinimal[];
}

const MAX_VISIBLE_TOPICS = 3;

export const TopicsCell = ({ topics }: IProps) => {
    const visibleTopics = topics.slice(0, MAX_VISIBLE_TOPICS);
    const remainingCount = topics.length - MAX_VISIBLE_TOPICS;

    return (
        <Stack direction={"row"} flexWrap={"wrap"} gap={1}>
            {/* Topic Chips */}
            {visibleTopics.map(({ name }, index) => (
                <Chip
                    key={`topic-${name}-${index}`}
                    label={name}
                    size={"small"}
                    color={"tertiary"}
                />
            ))}

            {/* Overflow indicator */}
            {remainingCount > 0 && (
                <Chip
                    label={`+${remainingCount}`}
                    size={"small"}
                    variant="outlined"
                    sx={{ fontWeight: 500 }}
                />
            )}

            {/*  Zero State */}
            {topics.length === 0 && (
                <Typography variant="body2" color="text.secondary">
                    -
                </Typography>
            )}
        </Stack>
    );
};
